import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JwtGuard } from './modules/shared/guards/jwt.guard';
import { UnauthorizedComponent } from './modules/shared/components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },{
    path: 'files',
    loadChildren: () => import('./modules/files/files.module').then(m => m.FilesModule),
    canActivate: [JwtGuard]
  },{
    path: 'users',
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
    canActivate: [JwtGuard]
  },{
    path: 'households/:householdId',
    loadChildren: () => import('./modules/households/households.module').then(m => m.HouseholdsModule),
    canActivate: [JwtGuard]
  },{
    path: 'file-review',
    loadChildren: () => import('./modules/file-review/file-review.module').then(m => m.FileReviewModule),
    canActivate: [JwtGuard]
  },{
    path: 'unauthorized',
    component: UnauthorizedComponent
  },{
    // FirmOsjModule lazy entry. MUST stay below every specific top-level
    // route — `path: ''` with default `pathMatch: 'prefix'` matches every
    // URL, so anything below it is unreachable. Inside FirmOsjModule the
    // imported UsersModule contributes a `**` redirect to `households`,
    // which is why misordering this entry sent /file-review/* to the
    // households list.
    path: '',
    loadChildren: () => import('./modules/firm-osj/firm-osj.module').then(m => m.FirmOsjModule),
    canActivate: [JwtGuard]
  },{
    path: '**',
    redirectTo: 'auth'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
